import { useState } from 'react';
import { Info } from 'lucide-react';
import i18n from '@/settings/i18n';

const t = i18n.init('product');

const Disclaimer = () => (
  <div className="absolute left-0 top-[calc(100%+6px)] z-10 w-screen max-w-[calc(100vw-40px)] whitespace-normal xs:max-w-[350px]">
    <div className="rounded-md border bg-white px-3 py-2 text-center text-xs font-normal leading-tight text-gray-700 shadow-lg xs:px-5 xs:py-4">
      {t`Every device sold on Reebelo is fully unlocked and compatible with all carriers.`}
    </div>
  </div>
);

export default function UnlockedBadge() {
  const [showDisclaimer, setShowDisclaimer] = useState(false);

  return (
    <span className="ml-1 inline-flex align-middle">
      <button
        type="button"
        className="flex -translate-y-0.5 items-center focus:outline-none"
        onClick={() => setShowDisclaimer(!showDisclaimer)}
        onBlur={() => setShowDisclaimer(false)}
        onMouseEnter={() => setShowDisclaimer(true)}
        onMouseLeave={() => setShowDisclaimer(false)}
        aria-label="Unlocked device information"
      >
        <Info className="h-4 w-4 text-gray-700" />
      </button>
      {showDisclaimer && <Disclaimer />}
    </span>
  );
}
